import React from 'react'

const ClientExpCore = ({clientexp}) => {
  return (
    <div>
        <div className="row  g-4 d-flex  justify-content-center">
          {clientexp.map((val, i) => (
            <div
              className="col-lg-4 col-md-6 col-12   mb-4 "             
              key={i}
            ><div className='border-dark border rounded-4 position-relative h-100 overflow-hidden p-4'>
 
          
              <div className="d-flex justify-content-start align-items-center">
                <img
                  src={val.icon}
                  alt="icons "
                  style={{ width: 64, height: 64, borderRadius: "50%" }}
                  className="m-0"
                />
                <div className="ms-3">
                  <h5 className="h3-heading fs-4 d-inline fw-semibold ">{val.name}</h5>
                  {/* <p className="h3-para d-block lh-base ">{val.undername}</p> */}
                </div>
              </div>
              <div>
                <p className="mt-3  mb-4 fs-6">{val.desc}</p>
              </div>
              <div className="d-flex justify-content-between align-items-center  position-absolute mt-3 " style={{bottom:18}}>
                <p className='h3-para pe-1'> overall satisfication </p>
                <div>
                  <i
                    class="fa fa-star"
                    style={{ color: "#F0AD4E" }}
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa fa-star"
                    style={{ color: "#F0AD4E" }}
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa fa-star"
                    style={{ color: "#F0AD4E" }}
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa fa-star"
                    style={{ color: "#F0AD4E" }}
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa fa-star"
                    style={{ color: "#F0AD4E" }}
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
              </div>
          ))}
        </div>
    </div>
  )
}

export default ClientExpCore